import React from 'react';

const CategorySyncModal = ({ 
  modalId = 'categorySyncModal', 
  isLoading = false, 
  categories = [], 
  syncStats = null,
  error = null,
  onCategoryClick = null
}) => {
  return (
    <>
      <style>{`
        .category-hover:hover {
          transform: scale(1.1);
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        }
      `}</style>
      <div className="modal fade" id={modalId} tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-xl" style={{ maxWidth: '1200px' }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Synchronisation des Catégories Glovo</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            {isLoading && (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                  <span className="visually-hidden">Chargement...</span>
                </div>
                <p className="mt-3 text-muted">Synchronisation des catégories en cours...</p>
              </div>
            )}

            {error && !isLoading && (
              <div className="alert alert-danger" role="alert">
                <i className="fas fa-exclamation-triangle me-2"></i>
                {error}
              </div>
            )}

            {!isLoading && !error && syncStats && (
              <div className="mb-4">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="card bg-primary text-white">
                      <div className="card-body text-center">
                        <h3 className="mb-1">{syncStats.totalCategories || 0}</h3>
                        <small>Total</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-success text-white">
                      <div className="card-body text-center">
                        <h3 className="mb-1">{syncStats.created || 0}</h3>
                        <small>Créées</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-info text-white">
                      <div className="card-body text-center">
                        <h3 className="mb-1">{syncStats.updated || 0}</h3>
                        <small>Mises à jour</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-warning text-white">
                      <div className="card-body text-center">
                        <h3 className="mb-1">{syncStats.markedAsOld || 0}</h3>
                        <small>Marquées anciennes</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!isLoading && !error && categories && categories.length > 0 && (
              <div>
                <h6 className="mb-3">Catégories synchronisées</h6>
                <div className="row g-3">
                  {categories.map((category, index) => (
                    <div key={category._id || index} className="col-md-2 col-sm-3 col-4">
                      <div 
                        className="text-center"
                        style={{ cursor: onCategoryClick ? 'pointer' : 'default' }}
                        onClick={() => onCategoryClick && onCategoryClick(category)}
                      >
                        <div 
                          className={`rounded-circle bg-primary d-flex align-items-center justify-content-center mx-auto mb-2 ${onCategoryClick ? 'category-hover' : ''}`}
                          style={{ 
                            width: '80px', 
                            height: '80px',
                            fontSize: '2rem',
                            color: 'white',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          <i className="fas fa-folder"></i>
                        </div>
                        <p className="small mb-0 text-truncate" title={category.name}>
                          {category.name}
                        </p>
                        {category.totalProductCount !== undefined && (
                          <small className="text-muted">
                            {category.totalProductCount} produit{category.totalProductCount > 1 ? 's' : ''}
                          </small>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {!isLoading && !error && categories && categories.length === 0 && syncStats && (
              <div className="text-center py-5">
                <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                <p className="text-muted">Aucune catégorie à afficher</p>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default CategorySyncModal;
